<div class="wrapper" [class.right-panel-open]="getRightPanelVisible()" [class.onboarding-mode]="isOnboarding">
  <!-- top navbar-->
  <app-header class="topnavbar-wrapper"></app-header>
  <!-- sidebar-->
  <app-sidebar class="aside-container" *ngIf="!isOnboarding"></app-sidebar>
  <!-- nodesidebar-->
  <app-nodesidebar class="nodesidebar" *ngIf="!isOnboarding"></app-nodesidebar>
  <!-- Main section-->
  <section class="section-container" [class.onboarding-full-width]="isOnboarding">
    <!-- Page content-->
    <main class="content-wrapper">
      <div class="page-container">
        <router-outlet></router-outlet>
      </div>
    </main>
  </section>
  <!-- Page footer-->
  <footer class="footer-container" app-footer *ngIf="!isOnboarding"></footer>
  <!-- Right panel-->
  <app-right-panel
    [visible]="getRightPanelVisible()"
    [src]="rightPanelUrl"
    *ngIf="!isOnboarding">
  </app-right-panel>
</div>
